import React, { Component } from 'react';
import Modal from 'react-modal'; //npm install --save react-modal
import Swal from 'sweetalert2';
import { getRequestParams, formatDate } from '../../helpers/globalfunctions.js';
import { TripStatus, LogType } from '../../helpers/fixcodes';
import { SelectBox } from 'devextreme-react/select-box';
import NumberFormat from 'react-number-format';
import DatePicker from "react-datepicker"; // npm install react - datepicker --save
import { CardTypes } from '../../helpers/fixcodes.js';
import { LoadPanel } from 'devextreme-react/load-panel';
import { PreviousPaymentComponent } from '../Shared/PreviousPaymentComponent';
import { DocumentsComponent } from '../Shared/DocumentsComponent';
import jsSHA from "jssha"; // npm install jssha
const customStyles = {
    content: {
        width: '60%'
    }
};
const position = { of: '#confirmdiv' };
const $ = window.$;
let currentTime = sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime"));
export class InvoicePaymentComponent extends Component {
    static displayName = InvoicePaymentComponent.name;

    constructor(props) {
        currentTime = sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime"));
        super(props);
        this.state = {
            isOpenModal: false,
            isSubmited: false,
            loadPanelVisible: false,
            isSystemFees: false,
            invoiceReceipts: [],
            customerId: 0,
            lblInvoiceNo: 0,
            lblInvoiceDate: '',
            lblBillAmount: 0.00,
            lblPaidAmount: 0.00,
            lblDiscount: 0.00,
            lblWriteOffAmount: 0.00,
            lblDueAmount: 0.00,

            discountAmount: 0.00,
            writeoffAmount: 0.00,
            depositAmount: 0.00,
            paidDate: currentTime,
            depositedBy: '',
            invoiceNotes: '',

            dropdownPaymentMode: [],
            paymentModeId: 1,
            cardExpiry: "",
            cardType: "",
            cardImage: 'data:image/svg+xml;base64,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',
            creditCard: "",
            checkNumber: "",
            checkDate: currentTime,
            checkBank: "",
            chkPaymentGatewaySelection: "1",

            firstName: "",
            lastName: "",
            mobileNumber: "",
            email:"",

            errors: {
                paymentModeId: "",
                depositAmount: "",
                paidDate: "",
                depositedBy: "",
                checkNumber: "",
                checkDate: "",
                checkBank: "",
                creditCard: "",
                cardType: "",
                cardExpiry: "",

                firstName: "",
                lastName: "",
                mobileNumber: "",
                email: "",
            }
        }
        this.showModal = this.showModal.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.afterOpenPaymentModal = this.afterOpenPaymentModal.bind(this);
        this.handleInvoicePaymentSubmit = this.handleInvoicePaymentSubmit.bind(this);

        this.getPaymentMode = this.getPaymentMode.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handlePaymentModeChange = this.handlePaymentModeChange.bind(this);
        this.handlePreviousPayments = this.handlePreviousPayments.bind(this);

        this.handlePaymentGatewaySelectionChange = this.handlePaymentGatewaySelectionChange.bind(this);

        this.cardExpiry = this.cardExpiry.bind(this);
        this.limitMonthCreditCard = this.limitMonthCreditCard.bind(this);
        this.limitYearCreditCard = this.limitYearCreditCard.bind(this);
    }

    async getPaymentMode() {

        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('paymentmode-api/dropdownlist', requestParams);
            const data = await response.json();
            this.setState({
                dropdownPaymentMode: data.paymentMode
            });
        } catch (e) {
            console.log(e);
        }
    }

    async handleAmountChange(ctrl, value) {
        value = (value == undefined) ? 0 : value;
        if (ctrl === "discountAmount") {

            if (parseFloat(value) > (parseFloat(this.state.lblDueAmount) - parseFloat(this.state.writeoffAmount))) {
                const isValid = await Swal.fire({
                    title: "<small>Invalid Discount</small>",
                    text: "Discount amount should not be greater than (Due amount - Write-Off Amount).",
                    icon: "info",
                    width: '25%',
                    dangerMode: false,
                    allowOutsideClick: false
                });
                this.setState({
                    [ctrl]: 0.00,
                    depositAmount: parseFloat(this.state.lblDueAmount) - parseFloat(0.00) - parseFloat(this.state.writeoffAmount)
                });

            } else {
                this.setState({
                    [ctrl]: value,
                    depositAmount: parseFloat(this.state.lblDueAmount) - parseFloat(value) - parseFloat(this.state.writeoffAmount)
                });
            }
        } else if (ctrl === "writeoffAmount") {

            if (parseFloat(value) > (parseFloat(this.state.lblDueAmount) - parseFloat(this.state.discountAmount))) {
                const isValid = await Swal.fire({
                    title: "<small>Invalid Discount</small>",
                    text: "Discount amount should not be greater than (Due amount - Discount Amount).",
                    icon: "info",
                    width: '25%',
                    dangerMode: false,
                    allowOutsideClick: false
                });
                this.setState({
                    [ctrl]: 0.00,
                    depositAmount: parseFloat(this.state.lblDueAmount) - parseFloat(0.00) - parseFloat(this.state.discountAmount)
                });

            } else {
                this.setState({
                    [ctrl]: value,
                    depositAmount: parseFloat(this.state.lblDueAmount) - parseFloat(value) - parseFloat(this.state.discountAmount)
                });
            }
        } else if (ctrl === "depositAmount") {
            if (parseFloat(value) > (parseFloat(this.state.lblDueAmount) - parseFloat(this.state.discountAmount) - parseFloat(this.state.writeoffAmount))) {
                const isValid = await Swal.fire({
                    title: "<small>Invalid Amount</small>",
                    text: "Deposit amount should not be greater than (Due amount - Discount amount - Write-off amount).",
                    icon: "info",
                    width: '25%',
                    dangerMode: false,
                    allowOutsideClick: false
                });
                this.setState({
                    [ctrl]: 0.00
                });
            } else {
                this.setState({
                    [ctrl]: value,
                });
            }
        }
    }

    handlePaymentModeChange(selectedOption) {
        this.setState({ paymentModeId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })

        this.setState({
            checkNumber: "",
            checkDate: "",
            checkBank: "",
            creditCard: "",
            cardType: "",
            cardExpiry: "",
            chkPaymentGatewaySelection: "1",
            firstName: "",
            lastName: "",
            mobileNumber: "",
            email: "",
        });
        this.state.errors["checkNumber"] = "";
        this.state.errors["checkBank"] = "";
        this.state.errors["checkDate"] = "";
        this.state.errors["creditCard"] = "";
        this.state.errors["cardType"] = "";
        this.state.errors["cardExpiry"] = "";
        this.state.errors["firstName"] = "";
        this.state.errors["lastName"] = "";
        this.state.errors["mobileNumber"] = "";
        this.state.errors["email"] = "";
    }

    closeModal() {
        this.setState({
            isOpenModal: false,
            isSubmited: false,
            loadPanelVisible: false,
            invoiceReceipts: [],
            customerId: 0,
            lblInvoiceNo: 0,
            lblInvoiceDate: '',
            lblBillAmount: 0.00,
            lblPaidAmount: 0.00,
            lblDiscount: 0.00,
            lblWriteOffAmount: 0.00,
            lblDueAmount: 0.00,

            discountAmount: 0.00,
            writeoffAmount: 0.00,
            depositAmount: 0.00,
            paidDate: currentTime,
            depositedBy: '',
            invoiceNotes: '',

            dropdownPaymentMode: [],
            paymentModeId: 1,
            cardExpiry: "",
            cardType: "",
            cardImage: 'data:image/svg+xml;base64,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',
            creditCard: "",
            checkNumber: "",
            checkDate: currentTime,
            checkBank: "",
            chkPaymentGatewaySelection: "1",

            firstName: "",
            lastName: "",
            mobileNumber: "",
            email: "",

            errors: {
                paymentModeId: "",
                depositAmount: "",
                paidDate: "",
                depositedBy: "",
                checkNumber: "",
                checkDate: "",
                checkBank: "",
                creditCard: "",
                cardType: "",
                cardExpiry: "",
                firstName: "",
                lastName: "",
                mobileNumber: "",
                email: "",
            }
        });
    }

    async showModal(pageName, invoiceNo, customerId, _isSystemFees) {

        this.setState({
            isOpenModal: true,
            pageName: pageName,
            lblInvoiceNo: invoiceNo,
            customerId: customerId,
            loadPanelVisible: true,
            isSystemFees: _isSystemFees

        });
        await this.getPaymentMode();
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('receipt-api/' + invoiceNo, requestParams);
            const data = await response.json();
            if (data.invoiceReceipt != null && data.invoiceReceipt.length > 0) {
                this.setState({
                    lblDiscount: data.invoiceReceipt[0].invoiceDiscount,
                    lblWriteOffAmount: data.invoiceReceipt[0].invoiceWriteOffAmount,
                    lblInvoiceDate: new Date(data.invoiceReceipt[0].invoiceDate).toLocaleDateString(),
                    lblBillAmount: data.invoiceReceipt[0].billAmount,
                    lblDueAmount: data.invoiceReceipt[0].dueAmount,
                    lblPaidAmount: data.invoiceReceipt[0].invoicePaidAmount,
                    depositAmount: data.invoiceReceipt[0].dueAmount,
                    invoiceReceipts: data.invoiceReceipt
                });

            } else {
                var requestInvoice = new Object();

                requestInvoice.CustomerTypeId = 0;
                requestInvoice.IsInvoieApproved = true;
                requestInvoice.InvoiceFromDate = "";
                requestInvoice.InvoiceToDate = "";
                requestInvoice.InvoiceNo = parseInt(invoiceNo);
                requestInvoice.CustomerId = 0;
                requestInvoice.InvoiceStatus = 0;

                const requestParamsInvoice = getRequestParams('POST', requestInvoice);
                const responseInvoice = await fetch('invoice-api/list', requestParamsInvoice);
                const dataInvoice = await responseInvoice.json();

                this.setState({
                    lblDiscount: dataInvoice.invoiceList[0].discountAmount,
                    lblWriteOffAmount: dataInvoice.invoiceList[0].writeOffAmount,
                    lblInvoiceDate: new Date(dataInvoice.invoiceList[0].invoiceDate).toLocaleDateString(),
                    lblBillAmount: dataInvoice.invoiceList[0].billAmount,
                    lblDueAmount: dataInvoice.invoiceList[0].dueAmount,
                    lblPaidAmount: dataInvoice.invoiceList[0].paidAmount,
                    depositAmount: dataInvoice.invoiceList[0].dueAmount,
                });

            }

        } catch (e) {
            console.log(e);
        }

        this.setState({

            loadPanelVisible: false,
        });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === "creditCard") {
            const re = /^[0-9\b]+$/;
            CardTypes.forEach((item) => {
                if (event.target.value.trim().match(item.pattern)) {
                    this.setState({ cardType: item.name, cardImage: item.image })
                }
            })

            this.setState({ creditCard: event.target.value })
            if (event.target.value === "") {
                this.setState({ cardType: "", cardImage: "" })
            }
            this.state.errors["cardType"] = "";
        } else if (name === "checkNumber") {
            const re = /^[0-9\b]+$/;
            if (event.target.value === '' || re.test(event.target.value)) {
                this.setState({ checkNumber: event.target.value })
                this.state.errors["checkNumber"] = "";
            }
        } else {
            this.setState({
                [name]: value
            });
            this.state.errors[name] = "";
        }
    }


    handlePaymentGatewaySelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ chkPaymentGatewaySelection: value });

        this.setState({
            checkNumber: "",
            checkDate: "",
            checkBank: "",
            creditCard: "",
            cardType: "",
            cardExpiry: "",
            firstName: "",
            lastName: "",
            mobileNumber: "",
            email: "",
        });
        this.state.errors["checkNumber"] = "";
        this.state.errors["checkBank"] = "";
        this.state.errors["checkDate"] = "";
        this.state.errors["creditCard"] = "";
        this.state.errors["cardType"] = "";
        this.state.errors["cardExpiry"] = "";
        this.state.errors["firstName"] = "";
        this.state.errors["lastName"] = "";
        this.state.errors["mobileNumber"] = "";
        this.state.errors["email"] = "";
    }

    handleValidation() {

        let errors = this.state.errors;
        let formIsValid = true;
        errors.paymentModeId = "";
        errors.depositAmount = "";
        errors.paidDate = "";
        errors.depositedBy = "";
        errors.checkNumber = "";
        errors.checkBank = "";
        errors.checkDate = "";
        errors.creditCard = "";
        errors.cardType = "";
        errors.cardExpiry = "";
        errors.firstName = "";
        errors.lastName = "";
        errors.mobileNumber = "";
        errors.email = "";
     
        if (this.state.paymentModeId === 5) {
            if (parseFloat(this.state.depositAmount) === 0) {
                formIsValid = false;
                errors.depositAmount = "Please enter deposit amt.";
            }
        }
        if (this.state.paidDate === "") {
            formIsValid = false;
            errors.paidDate = "Please enter paid date.";
        }
        if (this.state.depositedBy === "") {
            formIsValid = false;
            errors.depositedBy = "Please enter deposited by.";
        }
        if (this.state.paymentModeId === 0) {
            formIsValid = false;
            errors.paymentModeId = "Please select payment mode.";
        }
        if (parseInt(this.state.chkPaymentGatewaySelection) == 2 && this.state.paymentModeId === 5) {
            if (this.state.creditCard.trim() === "") {
                formIsValid = false;
                errors.creditCard = "Please select or enter card.";
            }

            if (this.state.cardType === "") {
                formIsValid = false;
                errors.cardType = "Please select card type.";
            }

            if (this.state.cardExpiry === "") {
                formIsValid = false;
                errors.cardExpiry = "Please enter card expiry.";
            }
        }

        if (parseInt(this.state.chkPaymentGatewaySelection) == 1 && this.state.paymentModeId === 5) {
            if (this.state.firstName.trim() === "") {
                formIsValid = false;
                errors.firstName = "Please enter first name.";
            }

            if (this.state.lastName.trim() === "") {
                formIsValid = false;
                errors.lastName = "Please enter last name.";
            }

            if (this.state.mobileNumber.trim() === "") {
                formIsValid = false;
                errors.mobileNumber = "Please enter mobile.";
            } else if (this.state.mobileNumber.trim().replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length != 10) {
                formIsValid = false;
                errors.mobileNumber = "Invalid mobile number.";
            }

            if (this.state.email.trim() === '') {
                formIsValid = false;
                errors.email = "Please enter email.";
            }
            if (this.state.email != '') {
                let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!regEmail.test(this.state.email)) {
                    formIsValid = false;
                    errors.email = "Please enter valid email.";
                }
            }
        }

        if (this.state.paymentModeId === 2) {
            if (this.state.checkNumber === "") {
                formIsValid = false;
                errors.checkNumber = "Please enter check number.";
            }

            if (this.state.checkBank === "") {
                formIsValid = false;
                errors.checkBank = "Please enter bank name.";
            }

            if (this.state.checkDate === "") {
                formIsValid = false;
                errors.checkDate = "Please enter check date.";
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    async askConfirmQuoteConfirm() {
        let isResult = false;
        await Swal.fire({
            title: "<small>Are you sure</small>",
            html: "You are going to payment for this Invoice!<br> Do you want to still continue?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continue',
            cancelButtonText: 'Close',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                isResult = true;
            }
        })
        return isResult;
    }

    async handleInvoicePaymentSubmit(e, isAttachment) {
        e.preventDefault();
        if (this.handleValidation()) {

            const isConfirm = await this.askConfirmQuoteConfirm();
            if (!isConfirm) {
                return;
            } else {
                try {

                    var newObject = new Object();
                    newObject.RowIndex = 0;
                    newObject.InvoiceNo = parseInt(this.state.lblInvoiceNo);
                    newObject.DepositAmount = parseFloat(this.state.depositAmount);
                    newObject.DueAmount = parseFloat(this.state.lblDueAmount) - parseFloat(this.state.discountAmount) - parseFloat(this.state.writeoffAmount) - parseFloat(this.state.depositAmount);
                    newObject.Discount = parseFloat(this.state.discountAmount);
                    newObject.WriteOffAmount = parseFloat(this.state.writeoffAmount);
                    newObject.PaidAmount = parseFloat(this.state.depositAmount);
                    newObject.PaymentTypeId = parseInt(this.state.paymentModeId);
                    newObject.CustomerId = parseInt(this.state.customerId);

                    newObject.ChequeBankName = this.state.checkBank;
                    newObject.ChequeNumber = this.state.checkNumber;
                    newObject.ChequeDate = parseInt(this.state.paymentModeId) == 2 ? new Date(this.state.checkDate).toLocaleDateString() : null;

                    newObject.CcNumber = parseInt(this.state.paymentModeId) == 5 ? this.state.creditCard : "";
                    newObject.CcExpiry = parseInt(this.state.paymentModeId) == 5 ? this.state.cardExpiry : "";
                    newObject.CcType = parseInt(this.state.paymentModeId) == 5 ? this.state.cardType : "";

                    newObject.PaidDate = new Date(this.state.paidDate).toLocaleDateString();
                    newObject.Note = this.state.invoiceNotes;
                    newObject.DepositBy = this.state.depositedBy;
                    newObject.PaymentGatewayId = parseInt(this.state.chkPaymentGatewaySelection);

                    this.setState({ isSubmited: true });
                    const requestParams = getRequestParams('POST', newObject);
                    const response = await fetch('receipt-api', requestParams);
                    const data = await response.json();

                    if (data.isSuccess == true && parseInt(this.state.chkPaymentGatewaySelection) == 1 && this.state.paymentModeId === 5) {
                        sessionStorage.setItem("session_invoice_receipt_attach", isAttachment);
                        var CreateTransactionRequest = new Object();
                        CreateTransactionRequest.TransactionSource = "UTWiz Invoice Payment";
                        CreateTransactionRequest.AccountId = Number(sessionStorage.getItem("session_accountId"));
                        CreateTransactionRequest.LocationId = Number(sessionStorage.getItem("session_locationId"));
                        CreateTransactionRequest.RideId = 0;
                        CreateTransactionRequest.ReservationId = 0;
                        CreateTransactionRequest.FirstName = this.state.firstName;
                        CreateTransactionRequest.LastName = this.state.lastName;
                        CreateTransactionRequest.EmailId = this.state.email;
                        CreateTransactionRequest.PhoneNo = this.state.mobileNumber;
                        CreateTransactionRequest.Amount = parseFloat(parseFloat(this.state.depositAmount).toFixed(2));
                        CreateTransactionRequest.OrderDetails = 'Invoice Payment';
                        CreateTransactionRequest.PlanId = 0;
                        CreateTransactionRequest.CustomerId = 0;
                        CreateTransactionRequest.InvoiceNo = parseInt(this.state.lblInvoiceNo);
                        CreateTransactionRequest.InvoiceReceiptNo = parseInt(data.retValue);
                        const transactionRequestParams = getRequestParams('POST', CreateTransactionRequest);
                        const transactionResponse = await fetch('payment-gateway-api/' + this.state.chkPaymentGatewaySelection + '/transaction', transactionRequestParams);
                        const transactionData = await transactionResponse.json();

                        let paymentUrl = "", paymentKey = "", paymentSalt = "", txnId = "";
                        if (transactionData.transactionId != null && transactionData.settings.length >= 3) {
                            txnId = transactionData.transactionId;
                            paymentUrl = transactionData.settings[0].settingValue;
                            paymentKey = transactionData.settings[1].settingValue;
                            paymentSalt = transactionData.settings[2].settingValue;
                            let dataStr = paymentKey + "|" + txnId + "|" + CreateTransactionRequest.Amount + "|" + "UTWiz Ride" + "|" + this.state.firstName + "|" + this.state.email + "|" + CreateTransactionRequest.TransactionSource + "|" + CreateTransactionRequest.OrderDetails + "|||||||||" + paymentSalt;
                            let hashObj = new jsSHA("SHA-512", "TEXT", { numRounds: parseInt(1, 10) });
                            hashObj.update(dataStr);
                            let hashValue = hashObj.getHash("HEX");
                            let paymentAppUrl = data.paymentAppUrl;
                            let postForm = '<form action="' + paymentUrl + '" method="post" id="frmPay">';
                            postForm += '<input type="hidden" id="key" name="key" value="' + paymentKey + '" />';
                            postForm += '<input type="hidden" name="salt" value="' + paymentSalt + '" />';
                            postForm += '<input type="hidden" id="firstname" name="firstname" value="' + this.state.firstName + '" />';
                            postForm += '<input type="hidden" id="lastname" name="lastname" value="' + this.state.lastName + '" />';
                            postForm += '<input type="hidden" id="surl" name="surl" value="' + paymentAppUrl + 'PayUMoney/TrnxSuccess" />';
                            postForm += '<input type="hidden" id="phone" name="phone" value="' + this.state.mobileNumber + '" />';
                            postForm += '<input type="hidden" id="hash" name="hash" value="' + hashValue + '" />';
                            postForm += '<input type="hidden" id="curl" name="curl" value="' + paymentAppUrl + 'PayUMoney/TrnxCancelledByUser" />';
                            postForm += '<input type="hidden" id="furl" name="furl" value="' + paymentAppUrl + 'PayUMoney/TrnxFailed" />';
                            postForm += '<input type="hidden" id="txnid" name="txnid" value="' + txnId + '" />';
                            postForm += '<input type="hidden" id="productinfo" name="productinfo" value="UTWiz Ride" />';
                            postForm += '<input type="hidden" id="amount" name="amount" value="' + CreateTransactionRequest.Amount + '" />';
                            postForm += '<input type="hidden" id="udf1" name="udf1" value="' + CreateTransactionRequest.TransactionSource + '" />';
                            postForm += '<input type="hidden" id="udf2" name="udf2" value="' + CreateTransactionRequest.OrderDetails + '" />';
                            postForm += '<input type="hidden" id="email" name="email" value="' + this.state.email + '" />';
                            postForm += '<input type="submit" value="submit">';
                            postForm += '</form>';
                            $(postForm).appendTo('body').submit();
                        }

                    } else {
                        Swal.fire({
                            icon: data.isSuccess ? 'success' : 'error',
                            title: data.isSuccess ? 'Success' : 'Oops...',
                            html: data.resultMessage,
                            width: "30%",
                            allowOutsideClick: false
                        }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (data.isSuccess) {
                                if (result.isConfirmed) {
                                    this.setState({ isSubmited: false });
                                    if (isAttachment == true) {
                                       
                                        this.props.getApprovedInvoices();
                                        var rideArray = [];
                                        rideArray.push(parseInt(data.retValue));
                                        this.refs.documentsComponent.showModal('Invoice Receipt', rideArray, rideArray[0]);

                                    } else {
                                        this.closeModal();
                                        this.props.getApprovedInvoices();
                                    }
                                }
                            } else {
                                this.setState({ isSubmited: false });
                            }
                        })
                    }


                } catch (e) {
                    console.log(e);
                }
            }
        }
    }

    afterOpenPaymentModal() {

    }

    handlePreviousPayments(e) {
        e.preventDefault();
        this.refs.previousPaymentComponent.showModal(this.state.invoiceReceipts, this.state.isSystemFees);
    }

    limitYearCreditCard(val, min) {
        if (val.length === 1 && val[0] < min[0]) {
            val = '0' + val;
        }

        if (val.length === 2) {
            if (Number(val) === 0) {
                val = '01';

                //this can happen when user paste number
            } else if (val < min) {
                val = min;
            }
        }

        return val;
    }

    limitMonthCreditCard(val, max) {
        if (val.length === 1 && val[0] > max[0]) {
            val = '0' + val;
        }

        if (val.length === 2) {
            if (Number(val) === 0) {
                val = '01';

                //this can happen when user paste number
            } else if (val > max) {
                val = max;
            }
        }

        return val;
    }

    cardExpiry(val) {
        let month = this.limitMonthCreditCard(val.substring(0, 2), '12');
        let date = this.limitYearCreditCard(val.substring(2, 4), currentTime.getFullYear().toString().substring(2, 4));
        let cardExpirydate = month + (date.length ? '/' + date : '');
        return cardExpirydate;

        //let month = this.limit(val.substring(0, 2), '12');
        //let year = val.substring(2, 4);
        //return month + (year.length ? '/' + year : '');
    }

    render() {
        return (
            <div>
                <Modal ariaHideApp={false}
                    isOpen={this.state.isOpenModal}
                    style={customStyles}
                    className={"react-modal"}
                    onAfterOpen={this.afterOpenPaymentModal}
                    onRequestClose={this.closeModal}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal">
                    <form method="post" onSubmit={this.handleInvoicePaymentSubmit} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                        <div className="modal-header">
                            <h6 className="modal-title">Invoice Payment</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeModal}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>

                        <div className="modal-body" id="confirmdiv">
                            <div className="row">
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label>Invoice Number</label>
                                        <div><strong>{this.state.lblInvoiceNo}</strong></div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label>Invoice Date</label>
                                        <div><strong>{this.state.lblInvoiceDate}</strong></div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label>Bill Amount</label>
                                        <div><strong>${parseFloat(this.state.lblBillAmount).toFixed(2)}</strong></div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label>Paid Amount</label>
                                        <div><strong>${parseFloat(this.state.lblPaidAmount).toFixed(2)}</strong></div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label>Discount</label>
                                        <div><strong>${parseFloat(this.state.lblDiscount).toFixed(2)}</strong></div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label>Write-Off</label>
                                        <div><strong>${parseFloat(this.state.lblWriteOffAmount).toFixed(2)}</strong></div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label>Due Amount</label>
                                        <div><strong>${parseFloat(this.state.lblDueAmount).toFixed(2)}</strong></div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label>Payment Method</label>
                                        <SelectBox
                                            dataSource={this.state.dropdownPaymentMode.length > 0 ? this.state.dropdownPaymentMode : []}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select payment mode"
                                            name="paymentModeId"
                                            defaultValue={0}
                                            value={this.state.paymentModeId}
                                            displayExpr='name'
                                            valueExpr='id'
                                            onSelectionChanged={this.handlePaymentModeChange}
                                            showClearButton={true}
                                            disabled={false}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["paymentModeId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["paymentModeId"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <div className="form-group">
                                        <label>Discount</label>
                                        <NumberFormat allowNegative={false} className="form-control form-control-sm" name="discountAmount" fixedDecimalScale={true} maxLength={12} prefix={'$'} decimalScale={3} title="Discount Amount" value={this.state.discountAmount} onValueChange={(values) => { this.handleAmountChange("discountAmount", values.floatValue) }} />
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <div className="form-group">
                                        <label>Write-Off</label>
                                        <NumberFormat allowNegative={false} className="form-control form-control-sm" name="writeoffAmount" fixedDecimalScale={true} maxLength={12} prefix={'$'} decimalScale={3} title="Discount Amount" value={this.state.writeoffAmount} onValueChange={(values) => { this.handleAmountChange("writeoffAmount", values.floatValue) }} />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label>Deposit Amount</label>
                                        <NumberFormat allowNegative={false} className="form-control form-control-sm" name="depositAmount" fixedDecimalScale={true} maxLength={12} prefix={'$'} decimalScale={3} title="Deposit Amount" value={this.state.depositAmount} onValueChange={(values) => { this.handleAmountChange("depositAmount", values.floatValue) }} />
                                        {this.state.errors["depositAmount"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["depositAmount"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <div className="form-group">
                                        <label>Paid Date </label>
                                        <DatePicker
                                            className="form-control form-control-sm "
                                            placeholderText="mm/dd/yyyy"
                                            name="validFrom"
                                            selected={this.state.paidDate}
                                            dateFormat="MM/dd/yyyy"
                                            onChange={date => this.setState({ paidDate: date })}
                                        />
                                        {this.state.errors["paidDate"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["paidDate"]}</span>}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Deposited By</label>
                                        <input type="text" className="form-control form-control-sm" name="depositedBy" placeholder="Enter deposited by" maxLength="50" title="Deposited By" value={this.state.depositedBy} onChange={this.handleInputChange} />
                                        {this.state.errors["depositedBy"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["depositedBy"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Notes</label>
                                        <input type="text" className="form-control form-control-sm" name="invoiceNotes" placeholder="Enter some notes" maxLength="100" title="Notes" value={this.state.invoiceNotes} onChange={this.handleInputChange} />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12" style={{ display: this.state.paymentModeId == 5 ? 'flex' : 'none' }}>
                                    <div className="form-group">
                                        <label htmlFor="">Payment Gateway</label><br />
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdPayUMoney" value="1" disabled={this.state.paymentModeId != 5} checked={this.state.chkPaymentGatewaySelection === "1"} onChange={this.handlePaymentGatewaySelectionChange} />
                                            <label className="form-check-label">PayUMoney</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdBraintree" value="2" disabled={this.state.paymentModeId != 5} checked={this.state.chkPaymentGatewaySelection === "2"} onChange={this.handlePaymentGatewaySelectionChange} />
                                            <label className="form-check-label">Braintree</label>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12" style={{ display: (this.state.chkPaymentGatewaySelection === "1" && this.state.paymentModeId == 5) ? 'flex' : 'none' }}>
                                    <div className="form-group">
                                        <label>First Name</label>
                                        <input type="text" className="form-control form-control-sm" name="firstName" placeholder="Enter first name" maxLength="50" title="First Name" value={this.state.firstName} onChange={this.handleInputChange} />
                                        {this.state.errors["firstName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["firstName"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12" style={{ display: (this.state.chkPaymentGatewaySelection === "1" && this.state.paymentModeId == 5) ? 'flex' : 'none' }}>
                                    <div className="form-group">
                                        <label>Last Name</label>
                                        <input type="text" className="form-control form-control-sm" name="lastName" placeholder="Enter last name" maxLength="50" title="Last Name" value={this.state.lastName} onChange={this.handleInputChange} />
                                        {this.state.errors["lastName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["lastName"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12" style={{ display: (this.state.chkPaymentGatewaySelection === "1" && this.state.paymentModeId == 5) ? 'flex' : 'none' }}>
                                    <div className="form-group">
                                        <label>Mobile Number <span className="text-danger">*</span></label>
                                        <NumberFormat className="form-control form-control-sm" name="mobileNumber" placeholder="(000) 000-0000" title="Mobile Number" value={this.state.mobileNumber} onChange={this.handleInputChange} format="(###) ###-####" />
                                        {this.state.errors["mobileNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["mobileNumber"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12" style={{ display: (this.state.chkPaymentGatewaySelection === "1" && this.state.paymentModeId == 5) ? 'flex' : 'none' }}>
                                    <div className="form-group">
                                        <label>Email <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control form-control-sm" name="email" placeholder="example@domain.com" maxLength="100" title="Email" value={this.state.email} onChange={this.handleInputChange} />
                                        {this.state.errors["email"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["email"]}</span>}
                                    </div>
                                </div>
                            </div>

                            <div className="row" style={{ display: this.state.paymentModeId !== 2 ? 'none' : 'flex' }}>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label>Check Number</label>
                                        <input type="text" className="form-control form-control-sm" name="checkNumber" disabled={this.state.paymentModeId !== 2} placeholder="Enter check number" maxLength="12" title="Check Number" value={this.state.checkNumber} onChange={this.handleInputChange} />
                                        {this.state.errors["checkNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["checkNumber"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label>Check Date</label>
                                        <DatePicker
                                            className="form-control form-control-sm "
                                            placeholderText="Select check date"
                                            name="checkDate"
                                            selected={this.state.checkDate}
                                            dateFormat="MM/dd/yyyy"
                                            onChange={date => this.setState({ checkDate: date })}
                                            disabled={this.state.paymentModeId !== 2}
                                        />
                                        {this.state.errors["checkDate"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["checkDate"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <div className="form-group">
                                        <label>Bank Name</label>
                                        <input type="text" className="form-control form-control-sm" disabled={this.state.paymentModeId !== 2} name="checkBank" placeholder="Enter bank name" maxLength="50" title="Bank Name" value={this.state.checkBank} onChange={this.handleInputChange} />
                                        {this.state.errors["checkBank"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["checkBank"]}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ display: (this.state.chkPaymentGatewaySelection === "1" || this.state.paymentModeId !== 5) ? 'none' : 'flex' }}>
                                <div className="col-lg-7 col-md-7 col-sm-7 col-xs-7" >
                                    <div className="form-group">
                                        <label>Card Number</label>
                                        <div className="input-group mb-3">
                                            <NumberFormat className="form-control form-control-sm" isNumericString={false} name="creditCard" placeholder="Enter credit card number" format="#### #### #### ####" disabled={this.state.paymentModeId !== 5} value={this.state.creditCard} onChange={this.handleInputChange} />
                                            <div className="input-group-append">
                                                <div className="input-group-text">
                                                    <img src={this.state.cardImage} width="20" />
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.errors["creditCard"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["creditCard"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3" >
                                    <div className="form-group">
                                        <label>Card Type</label>
                                        <select name="cardType" className="form-control form-control-sm" value={this.state.cardType} disabled={this.state.paymentModeId !== 5} onChange={this.handleInputChange}>
                                            <option value="0">Select card type</option>
                                            {
                                                CardTypes &&
                                                CardTypes.map((item, i) =>
                                                    (<option key={i} value={item.name}>{item.displayname}</option>))
                                            }
                                        </select>
                                        {this.state.errors["cardType"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["cardType"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <div className="form-group">
                                        <label>Card Expiry</label>
                                        <NumberFormat className="form-control form-control-sm" name="cardExpiry" disabled={this.state.paymentModeId !== 5} placeholder="MM/YY" format={this.cardExpiry} title="Credit Card Expiry" value={this.state.cardExpiry} onValueChange={(values) => { const { formattedValue, value } = values; this.setState({ cardExpiry: formattedValue }) }} />
                                        {this.state.errors["cardExpiry"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["cardExpiry"]}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-success btn-sm" onClick={(e) => { this.handleInvoicePaymentSubmit(e, false) }} >
                                {this.state.isSubmited && <span className="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isSubmited && <span className="Confirm"><i className="fas fa-check"></i> Confirm</span>}
                            </button>
                            <button type="submit" className="btn btn-success btn-sm" onClick={(e) => { this.handleInvoicePaymentSubmit(e, true) }} >
                                {this.state.isSubmited && <span className="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isSubmited && <span className="Confirm"><i className="fas fa-check"></i> Confirm & Attachment</span>}
                            </button>
                            {(this.state.invoiceReceipts.length > 0) && <button type="button" className="btn btn-custom-gray btn-sm" onClick={this.handlePreviousPayments} title="Previous Payments"><i className="fas fa-file-invoice"></i> Previous Payments</button>}
                            <button type="button" className="btn btn-custom-gray btn-sm" onClick={this.closeModal} title="Close"><i className="fas fa-times"></i> Close</button>
                        </div>
                        <PreviousPaymentComponent ref="previousPaymentComponent" />
                        <DocumentsComponent ref="documentsComponent" closeInvoicePayment={this.closeModal} />
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            visible={this.state.loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            closeOnOutsideClick={false}
                        />
                    </form>
                </Modal>
            </div>
        );
    }
}